import { ReactElement } from 'react';
import { documentationEmpty } from 'assets/icons';
import { InfoBanner } from 'components/general/InfoBanner';
import {
  EmptyListReason,
  EmptyTableInfo,
} from 'components/common/noTableContentInfo/NoTableContentInfo';

export function DocumentationEmpty({
  searchPhrase,
  loading,
  hasData,
}: {
  searchPhrase: string;
  loading: boolean;
  hasData: boolean;
}): ReactElement {
  return searchPhrase && searchPhrase.length > 0 && !loading && !hasData ? (
    <EmptyTableInfo
      emptyTableReason={EmptyListReason.SEARCHPHRASE_MISMATCH}
    />
  ) : (
    <InfoBanner
      icon={documentationEmpty}
      messageId='documentation_empty_info'
      dataQa='documentation_empty'
    />
  );
}
